import Vue from 'vue'
import * as onLoad from 'vue-onload'
Vue.use(onLoad.plugin);
